import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Global undo-kø
let toastCallback = null;

export function showUndo(message, onUndo, timeoutMs = 4000) {
  if (toastCallback) toastCallback(message, onUndo, timeoutMs);
}

export function UndoToastProvider() {
  const { t } = useTranslation();
  const [toast, setToast] = useState(null);

  useEffect(() => {
    toastCallback = (message, onUndo, timeoutMs) => {
      setToast({ message, onUndo, timeoutMs, id: Date.now() });
    };
    return () => { toastCallback = null; };
  }, []);

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(null), toast.timeoutMs);
    return () => clearTimeout(timer);
  }, [toast?.id]);

  const handleUndo = useCallback(() => {
    if (toast?.onUndo) toast.onUndo();
    setToast(null);
  }, [toast]);

  if (!toast) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 flex justify-center pointer-events-none">
      <div className="flex items-center gap-3 bg-slate-700 border border-slate-600 rounded-2xl px-4 py-3 shadow-2xl pointer-events-auto max-w-sm w-full">
        <p className="flex-1 text-sm text-slate-200">{toast.message}</p>
        <button type="button" onClick={handleUndo}
          className="text-blue-400 text-sm font-semibold shrink-0 active:text-blue-300 px-1">
          {t('common.undo')}
        </button>
        <button type="button" onClick={() => setToast(null)}
          className="text-slate-500 text-lg leading-none w-6 h-6 flex items-center justify-center shrink-0">
          ×
        </button>
      </div>
    </div>
  );
}
